"use client";

import React, { useState, useEffect } from "react";
import ThankYouModal from "../thank-you";
import StepIndicator from "./step-indicator";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";

interface StepsFormProps {
   lang?: string;
}

const StepsForm: React.FC<StepsFormProps> = ({ lang }) => {

    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        moveType: "",
        date: null as Date | null,
        movingFrom: "",
        squareMetersFrom: "",
        floorFrom: "",
        elevatorFrom: "",
        movingTo: "",
        squareMetersTo: "",
        floorTo: "",
        fullName: "",
        phone: "",
        email: "",
        comments: "",
        consent: false,
        cleaningservice: "",
        packingservice: "",
        warehousing: "",
    });

    const [showModal, setShowModal] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    // Функция для прокрутки к шагу с offset
    const scrollToStep = (stepNumber: number) => {
        setTimeout(() => {
            const element = document.getElementById(`step-${stepNumber}`);
            if (element) {
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - 150; // 150px выше элемента
                
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }, 100);
    };

    const nextStep = (data: Partial<typeof formData>) => {
        setFormData((prev) => ({ ...prev, ...data }));
        const nextStepNumber = step + 1;
        setStep(nextStepNumber);
        
        // Прокручиваем к следующему шагу после обновления состояния
        setTimeout(() => scrollToStep(nextStepNumber), 150);
    };

    const prevStep = () => {
        const prevStepNumber = step - 1;
        setStep(prevStepNumber);
        
        // Прокручиваем к предыдущему шагу после обновления состояния
        setTimeout(() => scrollToStep(prevStepNumber), 150);
    };


    const [isLoading, setIsLoading] = useState(false);

    const submitForm = async (data: Partial<typeof formData>) => {
        const finalData = { ...formData, ...data };

        setIsLoading(true);
      
        try {
          const response = await fetch('/api/send-email', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              formType: 'moving-request',
              formData: finalData
            }),
          });
      
          const result = await response.json();
      
          if (!response.ok || !result.success) {
            throw new Error('Failed to submit form');
          }
      
          // Показываем модальное окно успеха
          setShowModal(true);
          setTimeout(() => setIsVisible(true), 50);
      
          // Автоматическое закрытие через 5 секунд
          setTimeout(() => {
            setIsVisible(false);
            setTimeout(() => {
              setShowModal(false);
              window.location.href = "/";
            }, 500);
          }, 5000);
      
        } catch (error) {
          console.error('Form submission error:', error);
          // Здесь можно добавить обработку ошибки (показать сообщение пользователю)
        } finally {
          setIsLoading(false); 
        }
      };

    return (
        <>
            <StepIndicator step={step} />
            {step === 1 && (
                <Step1 
                    id="step-1"
                    onNext={nextStep} 
                    initialData={formData}  
                    lang={lang}
                />
            )}
            {step === 2 && (
                <Step2 
                    id="step-2"
                    onNext={nextStep} 
                    onPrev={prevStep} 
                    initialData={formData}  
                    lang={lang}
                />
            )}
            {step === 3 && (
                <Step3 
                    id="step-3"
                    onSubmit={submitForm} 
                    onPrev={prevStep} 
                    initialData={formData} 
                    isLoading={isLoading} 
                    lang={lang}
                />
            )}
            {showModal && (
                <div
                    className={`fixed inset-0 flex items-center justify-center bg-[#00000080] z-10 transition-opacity duration-500 ease-in-out 
                            ${isVisible ? "opacity-100" : "opacity-0 pointer-events-none"}`}
                    onClick={() => {
                        setIsVisible(false);
                        setTimeout(() => setShowModal(false), 500);
                    }}
                >
                    <div
                        className={`transform fixed transition-transform duration-500 ease-in-out
                                ${isVisible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <ThankYouModal
                            title={lang === "en" ? "Thank you!" : "Tack!"}
                            text={lang === "en" ? "Your request has been sent successfully. We will contact you shortly." : "Din förfrågan har skickats. Vi kommer att kontakta dig inom kort."}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default StepsForm;